"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MiniBagConfigurationProvider = void 0;
var _contexts = require("../contexts");
var _hooks = require("../hooks");
var _jsxRuntime = require("react/jsx-runtime");
const MiniBagConfigurationProvider = ({
  children
}) => {
  const miniBagConfiguration = (0, _hooks.useGetMiniBagConfigurationData)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_contexts.MiniBagConfigurationContextProvider, {
    value: miniBagConfiguration,
    children: children
  });
};
exports.MiniBagConfigurationProvider = MiniBagConfigurationProvider;
